<div class="content-app mat-typography" [ngStyle]=" isBlocked ? { 'overflow-y': 'hidden' } : {} " *ngIf="keycloakReady">
  <app-header [dataUser]="dataUser"></app-header>
  <mat-progress-bar class="loading-bar" color="accent" *ngIf="globalLoading" mode="indeterminate">
  </mat-progress-bar>
  <div class="layout" [ngClass]="{'expand': userNotEnroll}">
    <ng-container *ngIf="userNotEnroll ;else userEnroll">
      <div class="container-not-found">
        <app-not-found></app-not-found>
      </div>
    </ng-container>

    <ng-template #userEnroll>
      <ng-container *ngIf="menuUser.length > 0; else showLoading">
        <div class="layout-menu">
          <app-side-menu [menuUser]="menuUser"></app-side-menu>
        </div>
        <main class="layout-content">
          <router-outlet></router-outlet>
        </main>
      </ng-container>

      <ng-template #showLoading>
        <div class="loader-menu">
          <app-loading> </app-loading>
        </div>
      </ng-template>

    </ng-template>
  </div>
</div>

<div class="main-loader" *ngIf="!keycloakReady" aria-busy="true" aria-live="polite">
  <mat-spinner class="m-auto"></mat-spinner>
</div>

<div class="bloked" *ngIf="isBlocked" [ngClass]="getCss()">
  <div class="loading" *ngIf="dataBlocked" role="alert" aria-live="assertive">
    <p>{{dataBlocked.title}}</p>
    <mat-spinner class="m-auto"></mat-spinner>
    <p>{{dataBlocked.msg}}</p>
  </div>
</div>
